<template>
  <div id="login">
    <section class="hero is-success is-fullheight">
        <div class="hero-body">
          <div class="container has-text-centered">
            <div class="column is-4 is-offset-4">
              <h3 class="title has-text-grey">Login</h3>
              <p class="subtitle has-text-grey">Please login to proceed.</p>
              <div class="box">
                <figure class="avatar">
                  <img v-bind:src="'/static/img/logo.png'">
                </figure>
                <form @submit.prevent="login()">
                    <div class="title is-5 has-text-centered has-text-grey-dark"> Enter your details below </div>
                    <div class="field">                    
                        <bulma-input name="email" v-model="email" rules="required|email" placeholder='Your email'/>                    
                    </div>

                    <div class="field">                    
                        <bulma-input type="password" name="password" v-model="password" rules="required|min:6" placeholder='Your password'/>
                    </div>
                    <loading-submit v-bind:loading="loading" color="is-danger">Login</loading-submit>
                  <hr>
                  <div class="field">                    
                    <div class="control has-text-centered">
                        <a href="#" class="icon-button facebook is-size-3-mobile" @click="authenticate('facebook')"><i class="icon-facebook fab fa-facebook-f"></i><span></span></a>
                        <a href="#" class="icon-button google-plus is-size-3-mobile" @click="authenticate('google')"><i class="icon-google-plus fab fa-google-plus-g"></i><span></span></a>
                    </div>
                  </div>
                  
                </form>
              </div>
              <p class="has-text-grey">
              
                <router-link :to="'/register' + ($route.query.u ? '?u=' + $route.query.u : '')">
                    Sign up
                </router-link> &nbsp;·&nbsp;
                <router-link to="/forgot/password">
                    Forgot password?
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </section>    
  </div>  
</template>

<script>
import Vue from 'vue'
//import global from './mixins/globalMixins'

export default {
  name: 'login',
  components: {},
    mixins : [],
  data() {
        return {
            email: '',
            password: '',
            loading: false
        }
  },
  created(){


  },
  mounted(){   
   
        let social = this.$route.query.social;
        let self = this;
        if(social){
            setTimeout(function(){
                self.authenticate(social);
            }, 500);
        }                              
    
            

  },
  methods: {
    login: function(){
        
        this.$validator.validateAll().then((result) => {
	    if (result) {
                let self = this;            
                this.loading = true;
                this.$auth.login({ email: this.email, password: this.password }).then(function () {
                    self.loading = false;
                    self.$router.push(self.$route.query.redirect || self.checkToRedirect());
                }).catch(function(response){
                    self.loading = false;                    
                    return Promise.reject(response.response);
                });
            }
        });
    },

    checkToRedirect(){
        this.userRepo.me().then(response => {
            Vue.prototype.$me = response.data.data;

            if(this.$me.status === 'Unconfirmed') {
                this.$router.push('/confirm-your-mail');
            } else if(this.$me.subscription.expired){
                this.$router.push('/dashboard/profile');
            }
            else {
                this.initialRedirects();
            }
        });
    },
      initialRedirects(){
          if(!this.$me.profile || !this.$me.profile.school){
              this.$router.push('/dashboard/profile');
          }
          else{
              this.$router.push('/dashboard/comments');
          }
          //else if(this.news && this.news.length > 0){
              //this.$router.push('/dashboard/news');
          //}
      },
    authenticate: function (provider) {
        Vue.prototype.$referral = this.$route.query.u;
        var component = this;
        this.$auth.authenticate(provider).then(function () {
            component.$router.push('/dashboard/comments'); 
        }).catch(function(response){
            return Promise.reject(response.response);
        });
    }
  }
  
}
</script>

<style lang="css" scoped>

html,body {
  font-family: 'Open Sans', serif;
  font-size: 14px;
  font-weight: 300;
}
.hero.is-success {
  background: #f5f5f5;
}
.hero .nav, .hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.box {
  margin-top: 5rem;
}
.avatar {
  margin-top: -70px;
  padding-bottom: 20px;
}
.avatar img {
  padding: 5px;
  background: #fff;
  height: 200px;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
  box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
}
input {
  font-weight: 300;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}

html {
	font-size: 2.5em;
}
body {
	background-color: #fff;
	padding: 25px;
	text-align: center;
}



</style>



// WEBPACK FOOTER //
// src/Login.vue